export default "__VITE_ASSET__XuWJf$ar__"